import React from "react";
import { Link } from "react-router-dom";
import { Flower2 } from "lucide-react";
import { useT } from "@/lib/i18n";

export function Footer() {
  const { t } = useT();
  return (
    <footer className="bg-slate-brand text-stone-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid gap-8 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-gold text-slate-brand"><Flower2 size={18} /></span>
            <span className="font-extrabold text-white text-lg">{t("brand.name")}</span>
          </div>
          <p className="text-sm text-stone-400 measure">{t("footer.rights")}</p>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-3">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/discover" className="hover:text-terracotta-border">{t("nav.discover")}</Link></li>
            <li><Link to="/stories" className="hover:text-terracotta-border">{t("nav.stories")}</Link></li>
            <li><Link to="/verification" className="hover:text-terracotta-border">{t("nav.verification")}</Link></li>
            <li><Link to="/about" className="hover:text-terracotta-border">{t("nav.about")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-3">Participate</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/for-csr" className="hover:text-terracotta-border">{t("nav.forCsr")}</Link></li>
            <li><Link to="/for-ngos" className="hover:text-terracotta-border">{t("nav.forNgos")}</Link></li>
            <li><Link to="/faq" className="hover:text-terracotta-border">{t("nav.faq")}</Link></li>
            <li><Link to="/register" className="hover:text-terracotta-border">{t("common.register")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-3">{t("footer.dpo")}</h4>
          <ul className="space-y-2 text-sm text-stone-400">
            <li>Grievance & DPDP requests</li>
            <li><a href="mailto:dpo@thadam.org" className="hover:text-terracotta-border">dpo@thadam.org</a></li>
            <li>Resolution SLA: 90 days</li>
            <li className="pt-2 text-xs">Privacy · Terms · Verification disclaimer · Media & consent policy · Sponsorship independence</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-700/50 py-4 text-center text-xs text-stone-500">
        © 2026 The Great Indian Dream · A Lotus Group initiative, Coimbatore &amp; Erode · Free to search forever · ₹0 in fees, ever.
      </div>
    </footer>
  );
}

export default Footer;
